import {NormalizeForDiffOptions} from '../types';

const FANUC_IO_STATE_PATTERN =
  /(DI|DO|RI|RO|SI|SO|UI|UO|GI|GO|AI|AO|WI|WO)\[\s*(\d+)\s*:\s*((?:ON|OFF|ｵﾝ|ｵﾌ|\d+))\s*(:|\])/gi;

/**
 * FANUC TPの差分比較用に正規化する。
 *
 * 原文の行番号と内容は表示・ダウンロード用に保持し、ここで返す値は比較にだけ使う。
 * 行数を変えないことが原文行番号との対応を保つ不変条件である。
 *
 * 行末と /MN の行番号は常に正規化する。I/Oコメント欄の実行時状態は、ASCII表記
 * （ON/OFF）と日本語辞書の半角カタカナ表記（ｵﾝ/ｵﾌ）、数値を既定では比較から除外し、
 * includeVolatileState が true の場合だけ比較対象に残す。
 */
export const normalizeFanucTpForDiff = (
  lines: string[],
  options: NormalizeForDiffOptions = {}
): string[] => {
  const includeVolatileState = options.includeVolatileState ?? false;
  let section = '';

  return lines.map(line => {
    const normalizedEol = line.replace(/\r$/, '');
    const trimmedLine = normalizedEol.trim();

    if (trimmedLine.startsWith('/')) {
      section = trimmedLine.toUpperCase();
      return normalizedEol;
    }

    if (section !== '/MN') return normalizedEol;

    // FANUC /MNの行番号は本文に焼き込まれ、挿入時に後続行すべてがずれるため除去する。
    const withoutLineNumber = normalizedEol.replace(/^[ \t]*\d+:[ \t]?/, '');

    if (includeVolatileState) {
      // 実行時状態を残しつつ、I/O欄内の空白だけは常に正規化する。
      return withoutLineNumber.replace(
        FANUC_IO_STATE_PATTERN,
        (_match, ioType: string, ioNumber: string, state: string, suffix: string) =>
          `${ioType}[${ioNumber}:${state.toUpperCase()}${suffix}`
      );
    }

    // I/Oコメント欄の実行時状態だけを除去する。文字列コメントと区別できないON/OFF/数値は意図的に許容する。
    return withoutLineNumber.replace(FANUC_IO_STATE_PATTERN, '$1[$2$4');
  });
};
